<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					backgroundColor: {
						name: 'backgroundColor',
						defaultValue: '#ffffff',
						labelDesc: 'resource-bg-color',
						callback: function () {
							vm.resources.backgroundColor.defaultValue = this.colorValue;
							this.$root.$emit('changeBgConfigPage', {'backgroundColor': this.colorValue});
						},
					},
					src: {
						name: 'src',
						defaultValue: '',
						defaultValueOrigin: '',
						defaultValueSize: '',
						defaultValueRepeat: '',
						defaultValuePosition: '',
						defaultValueAttachment: '',
						labelDesc: 'bg-image',
						canRemove: true,
						callback: function () {
							vm.resources.src.defaultValue = this.value;
							vm.resources.src.defaultValueOrigin = this.origin;
							vm.resources.src.defaultValueSize = this.size;
							vm.resources.src.defaultValueRepeat = this.repeat;
							vm.resources.src.defaultValueAttachment = this.attachment;
							vm.resources.src.defaultValuePosition = this.position;

							this.$root.$emit('changeBgConfigPage', {
								'backgroundImage': this.value,
								'backgroundOrigin': this.origin,
								'backgroundRepeat': this.repeat,
								'backgroundSize': this.size,
								'backgroundPosition': this.position,
								'backgroundAttachment': this.attachment
							});
						},
					},
				}
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/base/sidebar/ResourcesPage.vue